import { render, staticRenderFns } from "./ProfitabilityAnalysis.vue?vue&type=template&id=2f4c9f48&scoped=true"
import script from "./ProfitabilityAnalysis.vue?vue&type=script&lang=js"
export * from "./ProfitabilityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityAnalysis.vue?vue&type=style&index=0&id=2f4c9f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4c9f48",
  null
  
)

export default component.exports